"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import type { MatchLevel } from "./youzu-lens-sdk";

interface MatchLevelSelectorProps {
  value: MatchLevel;
  onValueChange: (value: MatchLevel) => void;
}

export function MatchLevelSelector({
  value,
  onValueChange,
}: MatchLevelSelectorProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-muted-foreground whitespace-nowrap">
        Match level:
      </span>
      <div className="w-[160px]">
        <Select
          value={value}
          onValueChange={(v) => onValueChange(v as MatchLevel)}
        >
          <SelectTrigger>
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="exact">Strict</SelectItem>
            <SelectItem value="similar">Moderate</SelectItem>
            <SelectItem value="broad">Loose</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
